import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getStudents as onGetStudents,
    addNewStudent as onAddNewStudent,
    updateStudent as onUpdateStudent,
    deleteStudent as onDeleteStudent,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Student = () => {

    //meta title
    document.title = "Staffs | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [student, setStudent] = useState(null);
    const faculties = [];
    const departments = [];
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (student && student.uid) || '',
            first_name: (student && student.first_name) || '',
            last_name: (student && student.last_name) || '',
            sex: (student && student.sex) || '',
            matricule: (student && student.matricule) || '',
            usttb_id: (student && student.usttb_id) || '',
            father_firstname: (student && student.father_firstname) || '',
            mother_firstname: (student && student.mother_firstname) || '',
            mother_lastname: (student && student.mother_lastname) || '',
            tutor_name: (student && student.tutor_name) || '',
            tutor_phone: (student && student.tutor_phone) || '',
            family_situation: (student && student.family_situation) || '',
            birthdate: (student && student.birthdate) || '',
            birthplace: (student && student.birthplace) || '',
            phone: (student && student.phone) || '',
            residence_place: (student && student.residence_place) || '',
            residence_status: (student && student.residence_status) || '',
            
            
        },
        validationSchema: Yup.object({
           
            first_name: Yup.string().required("Veuillez saisir le prénom"),
            last_name: Yup.string().required("Veuillez saisir le nom"),
            civility: Yup.string().required("Veuillez saisir la civilité"),
            matricule: Yup.string().required("Veuillez saisir le matricule"),
            nationality: Yup.string().required("Veuillez saisir la nationalité"),
            phone: Yup.string().required("Veuillez saisir le téléphone"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateStudent = {
                    id: values.id,
                    uid: values.uid,
                    first_name: values.first_name,
                    last_name: values.last_name,
                    sex: values.sex,
                    matricule: values.matricule,
                    usttb_id: values.usttb_id,
                    father_firstname: values.father_firstname,
                    mother_firstname: values.mother_firstname,
                    mother_lastname: values.mother_lastname,
                    tutor_name: values.tutor_name,
                    tutor_phone: values.tutor_phone,
                    family_situation: values.family_situation,
                    birthdate: values.birthdate,
                    birthplace: values.birthplace,
                    phone: values.phone,
                    residence_place: values.residence_place,
                    residence_status: values.residence_status,
                    
                    
                };
                // update movie category
                dispatch(onUpdateStudent(updateStudent));
                validation.resetForm();
            } else {
                const newStudent = {
                    //id: values["id"],
                    //uid: values["uid"],
                    first_name: values["first_name"],
                    last_name: values["last_name"],
                    sex: values["sex"],
                    matricule: values["matricule"],
                    usttb_id: values["usttb_id"],
                    father_firstname: values["father_firstname"],
                    mother_firstname: values["mother_firstname"],
                    mother_lastname: values["mother_lastname"],
                    tutor_name: values["tutor_name"],
                    tutor_phone: values["tutor_phone"],
                    family_situation: values["family_situation"],
                    birthdate: values["birthdate"],
                    birthplace: values["birthplace"],
                    phone: values["phone"],
                    residence_place: values["residence_place"],
                    residence_status: values["residence_status"],
                   
                   
                };
                // save new movie category
                dispatch(onAddNewStudent(newStudent));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const StudentProperties = createSelector(
        (state) => state.studentReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students, loading} = useSelector(StudentProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (students && !students.length) {
            dispatch(onGetStudents());
        }
    }, [dispatch, students]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setStudent(null);
        } else {
            setModal(true);
        }
    };

    const handleStudentClick = arg => {
        const student = arg;
        setStudent({
            id: student.id,
            uid: student.uid,
            first_name: student.first_name,
            last_name: student.last_name,
            civility: student.civility,
            matricule: student.matricule,
            phone: student.phone,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (student) => {
        setStudent(student);
        setDeleteModal(true);
    };

    const handleDeleteStudent = () => {
        if (student && student.id) {
            
            dispatch(onDeleteStudent(student));
            setDeleteModal(false);
        }
    };

    const onClickNewStudent = () => {
        setIsEdit(false);
        setStudent(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Matricule",
                accessorKey: "matricule",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Prénom",
                accessorKey: "first_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nom",
                accessorKey: "last_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Civilité",
                accessorKey: "civility",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Téléphone",
                accessorKey: "phone",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleStudentClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteStudent}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Staffs" breadcrumbItem="Liste des staffs" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewStudent} className="btn btn-primary me-1">Ajouter un membre</Link> 
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={students || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                        backdrop={'static'}
                        id="staticBackdrop"
                        size="md"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Membre de staff" : "Ajouter - Membre de staff"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Prénom</Label>
                                            <Input
                                                name="first_name"
                                                type="text"
                                                placeholder="Prénom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.first_name || ""}
                                                invalid={
                                                    validation.touched.first_name && validation.errors.first_name ? true : false
                                                }
                                            />
                                            {validation.touched.first_name && validation.errors.first_name ? (
                                                <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                            ) : null}
                                        </div>

                                    

                                   

                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="last_name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.last_name || ""}
                                                invalid={
                                                    validation.touched.last_name && validation.errors.last_name ? true : false
                                                }
                                            />
                                            {validation.touched.last_name && validation.errors.last_name ? (
                                                <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                                            ) : null}
                                        </div>
                                    

                                      

                                        <div className="mb-3">
                                            <Label>Civilité</Label>
                                            <Input
                                                name="sex"
                                                type="select"
                                                value={validation.values.sex || ""}
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                invalid={
                                                    validation.touched.sex && validation.errors.sex ? true : false
                                                }
                                                >
                                                <option value="">Sélectionner</option>
                                                <option value="M.">Homme</option>
                                                <option value="Mme">Femme</option>
                                            </Input>
                                            {validation.touched.sex && validation.errors.sex ? (
                                                <FormFeedback type="invalid">{validation.errors.sex}</FormFeedback>
                                            ) : null}
                                        </div>


                                        

                                         </Col>  

                                    

                                         <Col className="col-12">      

                                       

                                        <div className="mb-3">
                                            <Label>Faculté</Label>
                                            <Input
                                                name="faculty_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.faculty_id || ""
                                                }
                                                invalid={
                                                    validation.touched.faculty_id && validation.errors.faculty_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {faculties.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.faculty_id && validation.errors.faculty_id ? (
                                                <FormFeedback type="invalid">{validation.errors.faculty_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Département</Label>
                                            <Input
                                                name="department_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.department_id || ""
                                                }
                                                invalid={
                                                    validation.touched.department_id && validation.errors.department_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {departments.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.department_id && validation.errors.department_id ? (
                                                <FormFeedback type="invalid">{validation.errors.department_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Service</Label>
                                            <Input
                                                name="department_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.department_id || ""
                                                }
                                                invalid={
                                                    validation.touched.department_id && validation.errors.department_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {departments.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.department_id && validation.errors.department_id ? (
                                                <FormFeedback type="invalid">{validation.errors.department_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                         </Col> 

                                        <Col className="col-12">

                                            <div className="mb-3">
                                                <Label>Fonction</Label>
                                                <Input
                                                    name="usttb_id"
                                                    type="text"
                                                    placeholder="Fonction"
                                                    validate={{
                                                        required: { value: true },
                                                    }}
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.usttb_id || ""}
                                                    invalid={
                                                        validation.touched.usttb_id && validation.errors.usttb_id ? true : false
                                                    }
                                                />
                                                {validation.touched.usttb_id && validation.errors.usttb_id ? (
                                                    <FormFeedback type="invalid">{validation.errors.usttb_id}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                       

                                        
                                        
                                    
                                        
                                       
                                        
                                        <Col className="col-12">

                                        

                                        <div className="mb-3">
                                            <Label>Téléphone</Label>
                                            <Input
                                                name="phone"
                                                type="text"
                                                placeholder="Téléphone"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.phone || ""}
                                                invalid={
                                                    validation.touched.phone && validation.errors.phone ? true : false
                                                }
                                            />
                                            {validation.touched.phone && validation.errors.phone ? (
                                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                                            ) : null}
                                        </div>
                                        </Col>
                                        
                                       
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Student;